// Inject Cloudinary delivery transformations into an existing Cloudinary URL so
// large source images (often multi-MB PNGs) are served as small, auto-format
// (WebP/AVIF), auto-quality, width-capped images — dramatically faster to load.
//
// Safe by design:
// - Non-Cloudinary URLs (e.g. local /assets/... paths) are returned unchanged.
// - URLs that already carry a transformation are returned unchanged (no double-apply).
// - c_limit only downscales (never upscales), so small images are never blurred bigger.
//
// Usage: optimizeCloudinary(slide.image, { width: 1920 })
const UPLOAD_MARKER = "/image/upload/";

export function optimizeCloudinary(url, { width } = {}) {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("res.cloudinary.com")) return url;

  const idx = url.indexOf(UPLOAD_MARKER);
  if (idx === -1) return url;

  const head = url.slice(0, idx + UPLOAD_MARKER.length);
  const tail = url.slice(idx + UPLOAD_MARKER.length);

  // Already transformed (our params or any leading transformation segment) — leave it.
  if (/^f_auto|q_auto|^[a-z]{1,3}_[^/]+\//.test(tail)) return url;

  const parts = ["f_auto", "q_auto"];
  if (width) parts.push(`w_${width}`, "c_limit");
  return `${head}${parts.join(",")}/${tail}`;
}
